import { experienceBuilderApi } from 'api'

export const fetchResources = (data: any) =>
  experienceBuilderApi.get<{
    data: any[]
    meta: { total: number; page: number; pageSize: number; totalPages: number }
    exploreMoreResources: any[]
  }>('/marketing-capabilities/resources', {
    params: {
      ...data,
    },
  })
